/**
 * Registry of active portal elements that are logically "inside" a component
 * even though they live outside its DOM subtree.
 *
 * OnBlurDetector checks this registry before deciding a click is "outside".
 */
const activePortals = new Set<Element>();

export const registerPortal = (el: Element): void => {
  activePortals.add(el);
};

export const unregisterPortal = (el: Element): void => {
  activePortals.delete(el);
};

export const clearPortals = (): void => {
  activePortals.clear();
};

export const isInsideActivePortal = (target: Element): boolean => {
  for (const el of activePortals) {
    if (el.contains(target)) return true;
  }

  return false;
};
